/* eslint-disable @angular-eslint/directive-selector */
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { NodeRenderer } from 'ngx-contentful-rich-text';
import { CONTENTFUL_PROPS } from '../types';

@Component({
  selector: 'nibtravel-inline-embedded-entry',
  template: `
    <ng-container *ngIf="inlineProps">
      {{ inlineProps | i18nParser: props }}
    </ng-container>
    <nibtravel-embedded-entry
      *ngIf="fields"
      [fields]="fields"
      [type]="type"
    ></nibtravel-embedded-entry>
  `,
})
export class InlineEmbeddedEntryComponent
  extends NodeRenderer
  implements OnInit
{
  inlineProps = '';
  fields!: Record<string, unknown>;
  type!: string;

  get isInlineProps() {
    // If it has a target, then it will have sys
    return this.node?.data?.target?.sys.contentType.sys.id === 'inlineContent';
  }

  constructor(
    @Optional() @Inject(CONTENTFUL_PROPS) public props: Record<string, any>
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.isInlineProps) {
      this.inlineProps = this.node.data.target.fields?.text;
    } else {
      const target = this.node?.data?.target;
      if (target?.fields) {
        this.fields = target.fields;
        this.type = target.sys.contentType.sys.id;
      }
    }
  }
}
